module.exports = __webpack_public_path__ + "img/Pista_21.a23ed02e.png";